import { api } from './client';
import type { ReviewItem } from '@/types/domain';

export interface ReviewInput {
  order_id: number;
  answers: { question_slug: string; value_5pt?: number; value_yesno?: boolean }[];
  comment?: string;
}

export async function submitReview(input: ReviewInput): Promise<ReviewItem> {
  return api.post('/reviews/', { body: input });
}

/** F-170 (B4.7) — inline review submitted from the per-order chat thread.
 *  The dedicated `MessageBubble` case posts a single `rating` value +
 *  optional `body`; backend maps these to the canonical review shape. */
export interface InlineReviewInput {
  order_id: number;
  rating: number;
  body?: string;
}

export async function submitInlineReview(input: InlineReviewInput): Promise<ReviewItem> {
  return api.post('/reviews/', { body: input });
}

/** F-170 (B0.16 / B4.7) — client dispute that flips a completed order
 *  back to `in_progress` and notifies the specialist. Backend lives at
 *  `POST /orders/<id>/dispute-completion/`. */
export async function disputeCompletion(orderId: number): Promise<void> {
  await api.post(`/orders/${orderId}/dispute-completion/`);
}

export async function fetchSpecialistReviews(
  slug: string,
  cursor?: string | null,
): Promise<{ results: ReviewItem[]; next_cursor: string | null }> {
  return api.get(`/specialists/${slug}/reviews/`, { query: { cursor: cursor ?? undefined } });
}
